<template>
  <div class="income-detail-wrap" v-loading="loadingPage">
    <div class="header">
      <div class="title">收益明细</div>
      <div class="search">
        <el-form inline class="inline-form" :model="searchForm" label-width="85px" label-position="left">
          <el-form-item label="交易时间">
            <el-date-picker
              v-model="comtime"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <!-- 1.通过来源商户搜索收益明细时，需要展示该商户下属所有门店（直属门店，不包括下级层级的门店）的收益明细； -->
          <el-form-item label="来源商户" style="margin-left: 30px">
           <el-select v-model="searchForm.merchantId" clearable placeholder="请选择">
            <el-option
              v-for="item in merchantList"
              :key="item.merchantId"
              :label="item.merchantName"
              :value="item.merchantId">
            </el-option>
          </el-select>
          </el-form-item>
         <!-- .通过来源门店搜索收益明细时，只展示该门店的收益明细； -->
          <el-form-item label="来源门店">
            <el-select v-model="searchForm.shopNo" clearable placeholder="请选择">
              <el-option
                v-for="item in shopList"
                :key="item.shopNo"
                :label="item.shopName"
                :value="item.shopNo">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收益状态">
            <el-select v-model="searchForm.profitState" clearable placeholder="请选择">
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-button type="primary" @click="search" class="btnBase searchBtn">查询</el-button>
        </el-form>
      </div>
    </div>
    <div class="table-list">
      <div class="summary">
        <div class="item">订单数：{{listResultEntity.orderSum}}单</div>
        <div class="item">累计收益：{{listResultEntity.sumProfit}}元</div>
        <div class="item">已结算收益：{{listResultEntity.settledProfit}}元</div>
        <div class="item">待结算收益：{{listResultEntity.toSettledProfit}}元</div>
      </div>
      <div class="tabledata-con">
        <el-table :data="listResultEntity.orderList" style="width: 100%" border v-loading="loadingTable">
          <el-table-column prop="payTime" label="交易时间" align="center"></el-table-column>
          <el-table-column prop="orderId" label="订单号" align="center"> </el-table-column>
          <el-table-column prop="shopName" label="交易门店" align="center"> </el-table-column>
          <el-table-column prop="merchantName" label="所属商户" align="center"> </el-table-column>
          <el-table-column prop="orderAmount" label="实收金额" align="center"> </el-table-column>
          <el-table-column prop="orderFee" label="订单费率" align="center"> </el-table-column>
          <el-table-column prop="signFee" label="签约费率" align="center"> </el-table-column>
          <el-table-column prop="profitAmount" label="收益" align="center"> </el-table-column>
          <el-table-column prop="profitState" label="收益状态" align="center"> </el-table-column>
        </el-table>
        <el-col :span="24" class="paginationBox">
          <el-pagination
            v-if="page.count > 0"
            class="pagination"
            :page-size="page.pageSize"
            layout="total, prev, pager, next, jumper"
            :total="page.count"
            :current-page="page.pageNo"
            @current-change="onChangeCurrentPage"
          ></el-pagination>
        </el-col>
      </div>
    </div>
  </div>
</template>
<script>
import { queryIncomeDetail, queryMerchantList, queryShopList } from "@/api/settle";
import { formatDate, getTodayStartTimestamp, getTodayEndTimestamp } from '@/utils/index';

export default {
  data() {
    return {
      comtime: [formatDate(getTodayStartTimestamp()), formatDate(getTodayEndTimestamp())],
      searchForm: {
        startTime: formatDate(getTodayStartTimestamp()),
        endTime: formatDate(getTodayEndTimestamp()),
        profitStatus: '',
        merchantId: JSON.parse(window.localStorage.getItem('LOGIN_INFO')).merchantId,
        shopNo: '',
      },
      statusList: [
        { label: '待提现', value: 0 },
        { label: '提现中', value: 1 },
        { label: '提现失败', value: 2 },
        { label: '待打款', value: 3 },
        { label: '打款失败', value: 4 },
        { label: '已打款', value: 5 },
        { label: '待入账', value: 9 },
      ],
      page: {
        pageNo: 1,
        count: 0,
        pageSize: 10,
      },
      listResultEntity: {
        orderSum: '',
        sumProfit: '',
        settledProfit: '',
        toSettledProfit: '',
        orderTotal: '',
        orderList: [],
      },
      loadingTable: false,
      loadingPage: false,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          },
        }],
      },
      merchantList: [],
      shopList: [],
    };
  },
  watch: {
    searchForm: {
      handler(newVal, oldVal) {
        // 判断是否结算门店先选
        if (oldVal.merchantId === '' && oldVal.shopNo !== '') {
          this.isMerchant = false;
        }
        // 判断是否结算商户先选
        if (oldVal.merchantId !== '' && oldVal.shopNo === '') {
          this.isMerchant = true;
        }
        // 结算门店和结算商户互斥
        if (oldVal.merchantId !== '' && oldVal.shopNo !== '') {
          // 根据先选判断清空哪个筛选条件
          if (this.isMerchant) {
            this.searchForm.shopNo = '';
          } else {
            this.searchForm.merchantId = '';
          }
          this.$message({
            message: '结算商户和结算门店只能选其一',
            type: 'warning',
          });
        }
      },
      deep: true,
    },
    comtime(val) {
      console.log(val);
      if (val) {
        this.searchForm.startTime = formatDate(val[0]);
        this.searchForm.endTime = formatDate(val[1]);
      } else {
        this.searchForm.startTime = '';
        this.searchForm.endTime = '';
      }
    },
  },
  methods: {
    search() {
      this.page.pageNo = 1;
      this.queryIncomeDetail();
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage(page) {
      this.page.pageNo = page;
      this.queryIncomeDetail();
    },
    statusToString(e) {
      switch (e) {
        case '0':
          return '待提现';
        case '1':
          return '提现中';
        case '2':
          return '提现失败';
        case '3':
          return '待打款';
        case '4':
          return '打款失败';
        case '5':
          return '已打款';
        case '9':
          return '待入账';
        default:
          return '待提现';
      }
    },
    // 获取收益明细
    queryIncomeDetail() {
      const params = Object.assign(this.searchForm, this.page);
      // 如果日期为空，不能查询
      if (!params.startTime) {
        this.$message({
          message: '查询日期必传',
          type: 'error',
        });
        return;
      }
      this.loadingPage = true;
      queryIncomeDetail(params).then((res) => {
        this.loadingPage = false;
        if (res.data.error_code === 0) {
          this.listResultEntity = res.data.data;
          this.page.count = res.data.data.orderTotal;
          if (this.listResultEntity) {
            this.listResultEntity.settledProfit = (this.listResultEntity.settledProfit / 1000000).toFixed(2);
            this.listResultEntity.sumProfit = (this.listResultEntity.sumProfit / 1000000).toFixed(2);
            this.listResultEntity.toSettledProfit = (this.listResultEntity.toSettledProfit / 1000000).toFixed(2);
          }
          this.listResultEntity.orderList.forEach((e) => {
            e.profitAmount = (e.profitAmount / 1000000).toFixed(2);
            e.orderAmount = (e.orderAmount / 100).toFixed(2);
            e.profitState = this.statusToString(e.profitState);
            // eslint-disable-next-line
            e.orderFee = (e.orderFee / 100).toFixed(2) + '%';
            // eslint-disable-next-line
            e.signFee = (e.signFee / 100).toFixed(2) + '%';

            // eslint-disable-next-line
            e.shopName = e.shopName + '\n' + e.merchantId;
            // eslint-disable-next-line
            e.merchantName = e.merchantName + '\n' + e.merchantId;
          });
        }
      }).catch(() => {
        this.loadingPage = false;
      });
    },
    queryMerchantList() {
      const loginInfo = JSON.parse(window.localStorage.getItem('LOGIN_INFO'));
      queryMerchantList({
        merchantId: loginInfo.merchantId,
        pageType: 1, // 0-结算页面；1-收益明细页面
      }).then((res) => {
        if (res.data.error_code === 0) {
          this.merchantList = res.data.data;
        }
      });
    },
    queryShopList() {
      const loginInfo = JSON.parse(window.localStorage.getItem('LOGIN_INFO'));
      queryShopList({
        merchantId: loginInfo.merchantId,
        pageType: 1, // 0-结算页面；1-收益明细页面
      }).then((res) => {
        if (res.data.error_code === 0) {
          this.shopList = res.data.data;
        }
      });
    },
  },
  mounted() {
    this.queryIncomeDetail();
    this.queryMerchantList();
    this.queryShopList();
  },
};
</script>
<style lang="scss">
.income-detail-wrap {
  .btnBase{
    height: 32px;
    margin-top: 5px;
    line-height: 0px;
  }
  .paginationBox {
    text-align: center;
  }
  background-color: #f7f7f7;
  > .header {
    .search{
      margin-top: 40px;
      // margin-bottom: 20px;
    }
    padding-left: 50px;
    background-color: #fff;
    .title {
      height: 80px;
      line-height: 80px;
      color: #333333;
      font-size: 18px;
      position: relative;
      &:after {
        content: "";
        display: block;
        height: 0px;
        border-bottom: 1px solid #f2f3f3;
        right: 0;
        bottom: 0;
        left: -50px;
        position: absolute;
      }
    }
    .el-range-separator {
      width: 20px;
    }
  }
  .table-list {
    background: #f7f7f7;
    overflow: hidden;
    .summary {
      border-top: 20px solid #eee;
      display: flex;
      align-items: center;
      width: 100%;
      background-color: #FAFAFA;
      padding-left: 50px;
      height: 80px;
      .item {
        margin-right: 40px;
      }
    }
    .tabledata-con {
      padding: 10px 50px 40px 50px;
      background: #fff;
      overflow: hidden;
      .el-table .cell {
        white-space: pre-line;
      }
      .table-btn {
        margin-right: 10px;
        cursor: pointer;
        color: #ff9c00;
      }
    }
  }
}
</style>
